export const actionTypes = [{ value: 'message', label: 'Message' }];
